import api from './api';

export const favoriteService = {
  /**
   * Get user's favorites with pagination
   * @param {number} page - Page number (default: 1)
   * @param {number} perPage - Items per page (default: 15)
   */
  async getFavorites(page = 1, perPage = 15) {
    try {
      const response = await api.get('/favorites', {
        params: {
          page,
          per_page: perPage,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Toggles a subject's favorite status using a POST request.
   * If isFavorite is true, adds to favorites. If false, removes from favorites.
   * @param {number} subjectId - Subject ID to toggle favorite status for
   * @param {boolean} isFavorite - True to favorite, false to unfavorite
   * @param {object} metadata - Optional metadata (reason, priority)
   * @param {string} metadata.reason - Reason for favoriting/unfavoriting
   * @param {string} metadata.priority - Priority level (low, medium, high)
   */
  async toggleFavorite(subjectId, isFavorite, metadata = {}) {
    try {
      const response = await api.post('/favorites', { // Always use /favorites endpoint
        subject_id: subjectId,
        action: isFavorite ? 'add' : 'remove', // Indicate action in payload
        metadata: {
          reason: metadata.reason || '',
          priority: metadata.priority || 'low',
          ...metadata,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};

